import React from 'react';

import Icons from '@/core/components/Icons';
import { useDonationUserSearch } from '@/core/lib/new-architecture/actions/savedSearch.actions';
import Query from '@/core/lib/new-architecture/query';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface DeleteHistoricalSearchButtonProps {
  hash: string;
  title: string;
}

const DeleteHistoricalSearchButton: React.FC<DeleteHistoricalSearchButtonProps> = ({ hash, title }) => {
  const { donationUserSearchDeleteMutation } = useDonationUserSearch();
  const { invalidateDonationsSearch } = Query.user.useInvalidate();
  const { t } = useTranslationContext(['common']);

  const handleOnDelete = () => {
    donationUserSearchDeleteMutation.mutate(hash, {
      onSuccess: async () => {
        await invalidateDonationsSearch();
      },
    });
  };
  const label = `${t('inputs.text.delete-historical', { ns: 'common' })} ${title}`;

  return (
    <button type="button" onClick={handleOnDelete} aria-label={label}>
      <Icons icon={donationUserSearchDeleteMutation.isPending ? 'spinner' : 'close'} />
    </button>
  );
};

export default DeleteHistoricalSearchButton;
